import api from '@/core/api'

export function useApi() {
  return api
}
